<template>
  <div class="content-panel">
    <knowledge-base-panel/>
  </div>
</template>

<script>
import KnowledgeBasePanel from "@/components/shared/KnowledgeBase/KnowledgeBasePanel.vue";

export default {
  name: "KartaPosudky",
  components: { KnowledgeBasePanel },
}
</script>

<style scoped>
.content-panel {
  height: calc(100vh - 80px);
  padding: 40px;
  overflow: hidden;
}

@media screen and (max-width: 767px) {
  .content-panel {
    height: calc(100vh - 64px);
    padding: 20px;
    overflow: auto;
  }
}
</style>
